/**
 * Waseem Collection - Conversion Rate Optimization Engine
 * Handles:
 * - Sticky Add to Cart & Sticky WhatsApp Bar
 * - Live Viewers Urgency Generator
 * - Same-Day Dispatch Countdown Timer
 * - WhatsApp URL Dynamic Variant & Quantity Synchronizer
 * - Floating WhatsApp Support Widget
 * - Recent Sales Social Proof Toasts
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', initWaseemConversion);

  function initWaseemConversion() {
    initUrgencyCounters();
    initCountdownTimer();
    initStickyATC();
    initWhatsAppVariantSync();
    initFloatingWhatsApp();
    initSalesPopup();
  }

  /* --------------------------------------------------------------------------
     1. Live Viewers & Stock Urgency
     -------------------------------------------------------------------------- */
  function initUrgencyCounters() {
    const viewerNumEl = document.getElementById('waseem-live-viewer-num');
    if (!viewerNumEl) return;

    let currentViewers = Math.floor(Math.random() * 8) + 12; // 12 to 19
    viewerNumEl.textContent = currentViewers;

    setInterval(function () {
      const change = Math.floor(Math.random() * 3) - 1; // -1, 0, or +1
      currentViewers = Math.max(9, Math.min(26, currentViewers + change));
      viewerNumEl.textContent = currentViewers;
    }, 7000);
  }

  /* --------------------------------------------------------------------------
     2. Dispatch Countdown Timer
     -------------------------------------------------------------------------- */
  function initCountdownTimer() {
    const timerElements = document.querySelectorAll('.waseem-countdown-clock');
    if (!timerElements.length) return;

    function getRemainingTime() {
      const now = new Date();
      // Cutoff time: 6:00 PM PKT (18:00:00)
      const cutoff = new Date(now);
      cutoff.setHours(18, 0, 0, 0);

      if (now.getTime() > cutoff.getTime()) {
        cutoff.setDate(cutoff.getDate() + 1);
      }

      const diff = cutoff.getTime() - now.getTime();
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      const pad = (n) => (n < 10 ? '0' + n : n);
      return `${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
    }

    function update() {
      const timeStr = getRemainingTime();
      timerElements.forEach((el) => {
        el.textContent = timeStr;
      });
    }

    update();
    setInterval(update, 1000);
  }

  /* --------------------------------------------------------------------------
     3. Sticky Add to Cart & Sticky WhatsApp Bar
     -------------------------------------------------------------------------- */
  function initStickyATC() {
    const stickyBar = document.getElementById('WaseemStickyATC');
    if (!stickyBar) return;

    const mainSubmitBtn = document.querySelector('.product-form__submit') || document.querySelector('button[name="add"]');
    if (!mainSubmitBtn) return;

    let isVisible = false;

    function checkScroll() {
      const rect = mainSubmitBtn.getBoundingClientRect();
      const scrollPassed = rect.bottom < 0;

      if (scrollPassed && !isVisible) {
        stickyBar.classList.add('waseem-sticky-atc--visible');
        document.body.classList.add('waseem-sticky-atc-active');
        isVisible = true;
      } else if (!scrollPassed && isVisible) {
        stickyBar.classList.remove('waseem-sticky-atc--visible');
        document.body.classList.remove('waseem-sticky-atc-active');
        isVisible = false;
      }
    }

    window.addEventListener('scroll', checkScroll, { passive: true });

    // Handle Sticky Add to Cart click
    const stickyAddBtn = document.getElementById('WaseemStickyAddToCartBtn');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () {
        if (mainSubmitBtn && !mainSubmitBtn.disabled) {
          stickyAddBtn.classList.add('loading');
          mainSubmitBtn.click();
          setTimeout(() => {
            stickyAddBtn.classList.remove('loading');
          }, 1000);
        }
      });
    }
  }

  /* --------------------------------------------------------------------------
     4. Dynamic Variant & Quantity Synchronizer for WhatsApp
     -------------------------------------------------------------------------- */
  function initWhatsAppVariantSync() {
    const mainForm = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
    if (!mainForm) return;

    const waBtn = document.querySelector('.waseem-whatsapp-order-btn');
    const stickyWaBtn = document.getElementById('WaseemStickyWhatsAppBtn');
    if (!waBtn && !stickyWaBtn) return;

    const waNum = (waBtn && waBtn.dataset.waNum) || '923186639550';
    const prodTitle = (waBtn && waBtn.dataset.productTitle) || document.title;
    const prodUrl = window.location.href;

    function updateWhatsAppLinks() {
      // Find current selected variant name if exists
      const variantPills = document.querySelectorAll('input[type="radio"]:checked, select.select__select');
      const selectedOpts = [];
      variantPills.forEach((el) => {
        if (el.value) selectedOpts.push(el.value);
      });

      const variantInfo = selectedOpts.length ? ` (Variant: ${selectedOpts.join(' / ')})` : '';

      // Find current price
      const priceElem = document.querySelector('.price__regular .price-item--regular, .price__sale .price-item--sale') || document.querySelector('.price-item');
      const priceText = priceElem ? priceElem.textContent.trim() : '';

      const message = `Assalam-o-Alaikum Waseem Collection! I want to order this suit: ${prodTitle}${variantInfo}${priceText ? ` (${priceText})` : ''}. Link: ${prodUrl}. Please confirm my Cash on Delivery order.`;
      const encodedUrl = `https://wa.me/${waNum}?text=${encodeURIComponent(message)}`;

      if (waBtn) waBtn.href = encodedUrl;
      if (stickyWaBtn) stickyWaBtn.href = encodedUrl;

      // Update sticky bar price if available
      const stickyPrice = document.querySelector('.waseem-sticky-atc__price');
      if (stickyPrice && priceText) {
        stickyPrice.textContent = priceText;
      }
    }

    mainForm.addEventListener('change', updateWhatsAppLinks);
  }

  /* --------------------------------------------------------------------------
     5. Floating WhatsApp Support Widget
     -------------------------------------------------------------------------- */
  function initFloatingWhatsApp() {
    const widget = document.getElementById('WaseemFloatingWA');
    if (!widget) return;

    const triggerBtn = document.getElementById('WaseemWATriggerBtn');
    const popup = document.getElementById('WaseemWAPopup');
    const closeBtn = document.getElementById('WaseemWACloseBtn');

    if (!triggerBtn || !popup) return;

    let isOpen = false;

    function toggleChat(e) {
      if (e) e.stopPropagation();
      isOpen = !isOpen;
      if (isOpen) {
        popup.classList.add('waseem-wa-popup--open');
        popup.setAttribute('aria-hidden', 'false');
        document.body.classList.add('waseem-wa-chat-open');
        // Remove unread badge once opened
        const badge = widget.querySelector('.waseem-floating-wa__badge');
        if (badge) badge.style.display = 'none';
      } else {
        popup.classList.remove('waseem-wa-popup--open');
        popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('waseem-wa-chat-open');
      }
    }

    triggerBtn.addEventListener('click', toggleChat);

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        isOpen = false;
        popup.classList.remove('waseem-wa-popup--open');
        popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('waseem-wa-chat-open');
      });
    }

    document.addEventListener('click', function (e) {
      if (isOpen && !widget.contains(e.target)) {
        isOpen = false;
        popup.classList.remove('waseem-wa-popup--open');
        popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('waseem-wa-chat-open');
      }
    });
  }

  /* --------------------------------------------------------------------------
     6. Recent Sales Social Proof Notifications
     -------------------------------------------------------------------------- */
  function initSalesPopup() {
    const popup = document.getElementById('WaseemSalesPopup');
    if (!popup) return;

    const closeBtn = document.getElementById('WaseemSalesPopupClose');
    const cityEl = document.getElementById('WaseemSalesCity');
    const productEl = document.getElementById('WaseemSalesProduct');
    const timeEl = document.getElementById('WaseemSalesTime');

    if (!cityEl || !productEl || !timeEl) return;

    const purchases = [
      { city: 'Someone in Lahore, Punjab', product: 'Imported Marina 3-Piece Embroidered Suit', time: '3 minutes ago' },
      { city: 'Someone in Karachi, Sindh', product: 'Gents Egyptian Cotton Unstitched Suit', time: '7 minutes ago' },
      { city: 'Someone in Islamabad', product: 'Luxury Unstitched Lawn 3PC with Silk Dupatta', time: '12 minutes ago' },
      { city: 'Someone in Faisalabad', product: 'All-Season Premium Wash & Wear Fabric', time: '16 minutes ago' },
      { city: 'Someone in Multan', product: 'Marina 3-Piece Embroidered Suit', time: '21 minutes ago' },
      { city: 'Someone in Rawalpindi', product: 'Ladies Embroidered Lawn 3-Piece Suit', time: '28 minutes ago' },
      { city: 'Someone in Gujranwala', product: 'Gents Classic Unstitched Suiting Fabric', time: '34 minutes ago' },
      { city: 'Someone in Sialkot', product: 'Marina 3PC Luxury Winter Collection', time: '41 minutes ago' },
      { city: 'Someone in Peshawar, KPK', product: 'Gents Egyptian Luster Cotton Suit', time: '49 minutes ago' }
    ];

    let currentIndex = 0;
    let isDismissed = false;

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popup.classList.remove('waseem-sales-popup--active');
        isDismissed = true;
      });
    }

    function showNextToast() {
      if (isDismissed) return;

      const item = purchases[currentIndex];
      cityEl.textContent = item.city;
      productEl.textContent = item.product;
      timeEl.textContent = item.time;

      popup.classList.add('waseem-sales-popup--active');

      // Stay visible for 5.5 seconds
      setTimeout(function () {
        popup.classList.remove('waseem-sales-popup--active');
      }, 5500);

      currentIndex = (currentIndex + 1) % purchases.length;
    }

    // Initial popup after 7 seconds
    setTimeout(function () {
      showNextToast();
      // Then repeat every 24 seconds
      setInterval(showNextToast, 24000);
    }, 7000);
  }
})();
